import { z } from "zod";

/**
 * This schema is incomplete.
 * Devs: please add fields here as needed.
 * @see /apps/dashboard/src/models/users.ts
 */
const userSchema = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string().nullable(),
  email: z.email().optional(),
  phone: z.string().nullable().optional(),
  created_at: z.iso.datetime({ offset: true }).optional(),
});

/**
 * A user within the Lendflow system.
 */
export type User = z.infer<typeof userSchema>;

export { userSchema };
